<!-- error message -->
<div *ngIf="isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
      <i class="icon-error"></i>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>

  </div>
</div>

<div *ngIf="!isErrorMessage">
  <h2 class="sectionTitle">{{ 'FRONT_USER.WORKSPACE.ChangeCrew_REPORT' | translate }}</h2>
  <div class="services-filter">

      <div class="form-container">
          <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>


          <div class="form-group">
              <label
                  for="txtCreationDateFrom">{{ 'SHARED.REPORTS.SMALLUNITS_REPORT.REQUEST_SUBMISSION_DATE_FROM' | translate}}</label>
              <input class="form-control" id="txtCreationDateFrom" name="txtCreationDateFrom" autocomplete="off"
                  #input="bsDatepicker" [(ngModel)]="creationDateFrom" bsDatepicker [minDate]='null'
                  [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
              <div class="red" *ngIf="showFromDateGreaterThanTodayDateMessage">
                  {{'SHARED.REPORTS.SMALLUNITS_REPORT.FROM_DATE_GREATER_THAN_TODAY_DATE_MESSAGE' | translate}}
              </div>
              <div class="red" *ngIf="showFromDateGreaterThanToDateMessage">
                  {{'SHARED.REPORTS.SMALLUNITS_REPORT.FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
              </div>

          </div>
          <div class="form-group">
              <label
                  for="txtCreationDateTo">{{ 'SHARED.REPORTS.SMALLUNITS_REPORT.REQUEST_SUBMISSION_DATE_TO' | translate}}</label>
              <input class="form-control" id="txtCreationDateTo" name="txtCreationDateTo" autocomplete="off"
                  #input="bsDatepicker" [(ngModel)]="creationDateTo" bsDatepicker [minDate]='null'
                  [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
          </div>
         <!-- <div class="form-group">
              <label for="dllServiceName">{{ 'SHARED.MYREQUESTS.ServiceName' | translate}}</label>
              <select class="form-control" id="dllServiceName" name="dllServiceName" [(ngModel)]="serviceId" (change)="changeService(serviceId, false)">
                  <option value="">--- {{'SHARED.AllServices' | translate}} ---</option>
                  <option *ngFor="let service of servicesList" value="{{service.Id}}">
                      {{lang == "Ar" ? service.NameAR : service.NameEN}}
                  </option>
              </select>
          </div>-->
          <div class="form-group">
              <label for="dllStatus">{{ 'SHARED.MYREQUESTS.Status' | translate}}</label>
              <select class="form-control" id="dllStatus" name="dllStatus" [(ngModel)]="serviceStatus">
                  <option value="">--- {{'SHARED.AllStatuses' | translate}} ---</option>
                  <option *ngFor="let status of statusesList" value="{{status.Id}}">
                      {{lang == "Ar" ? status.StatusAR : status.StatusEN}}
                  </option>
              </select>
          </div>

          <div class="form-group">
              <label for="txtRequestNumber">{{ 'SHARED.REPORTS.EBOOKING_OBJECT.RequestNumber' | translate}}</label>
              <input type="text" class="form-control" [(ngModel)]="requestNumber" autocomplete="off">
          </div>
          <!-- Transit Date -->
          <div class="form-group">
              <label
                  for="textTransitDate">{{ 'SHARED.REPORTS.SMALLUNITS_REPORT.TRANSIT_DATE' | translate}}</label>
              <input class="form-control" id="textTransitDate" name="textTransitDate" autocomplete="off"
                  #input="bsDatepicker" [(ngModel)]="transitDate" bsDatepicker [minDate]='null'
                  [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
          </div>
                     <!-- ETA -->
          <!-- <div class="form-group">
                      <label
                          for="txtEta">{{ 'SHARED.REPORTS.SMALLUNITS_REPORT.Eta' | translate}}</label>
                      <input class="form-control" id="txtEta" name="txtEta" autocomplete="off"
                          #input="bsDatepicker" [(ngModel)]="eta" bsDatepicker [minDate]='null'
                          [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
                  </div> -->
                      <!-- Sail Directions -->
          <div class="form-group">
                          <label for="ddlSailDirections">{{ 'SHARED.REPORTS.SMALLUNITS_REPORT.DIRECTIONS' | translate}}</label>
                          <select [(ngModel)]=" this.directionId" class="form-control" id="ddlSailDirections">
                              <option value="">--- {{'SHARED.REPORTS.SMALLUNITS_REPORT.ALL_DIRECTIONS' | translate}} ---</option>
                              <option *ngFor="let direction of sailDirections" value="{{direction?.Id}}">
                                  {{lang == "Ar" ? direction?.DirectionAR : direction?.Direction}}
                              </option>
                          </select>
                      </div>

  <!-- Unit Name  -->
          <div class="form-group">
      <label for="txtUnitName">{{ 'SHARED.MYREQUESTS.VesselName' | translate}}</label>
      <input type="text" class="form-control" [(ngModel)]="unitName" autocomplete="off">
           </div>






           <div class="form-group" *ngIf="isAdmin">
              <label for="txtUserName">{{ 'SHARED.REPORTS.EBOOKING_OBJECT.RequestorName' | translate}}</label>
              <div class="ng-autocomplete">
                  <ng-autocomplete [data]="agentsNamesList" [searchKeyword]="keyword" autocomplete="off"
                      (selected)='selectAgentNameEvent($event)' (inputChanged)='onAgentsNamesSearchChange($event)'
                      (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate"
                      [minQueryLength]="autoCompleteMinQueryLength" [notFoundTemplate]="notFoundTemplate"
                      [isLoading]="isAutoCompleteLoading" [(ngModel)]="userName"
                      placeHolder="{{'SHARED.REPORTS.AGENT_NAME_MIN_CHARS' | translate }}">
                  </ng-autocomplete>

                  <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item"></a>
                  </ng-template>

                  <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="this.agentNameNotFoundMessage"></div>
                  </ng-template>
              </div>
           </div>
        <!--isCompleted -->
        <div  class="form-group">
            <label for="CompletedCheckbox">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.Completed' | translate }}</label>
          <div class="custom-checkbox">
            <input type="checkbox"  name="CompletedCheckbox" id="CompletedCheckbox"
            [(ngModel)]="isCompleted">
            <label for="CompletedCheckbox">Yes</label>
          </div>
        </div>


      </div>

      <div class="btns-holder text-center">
          <input type="button" class="btn btn-primary SCAcustomBtn" (click)="getCrewChangeReportData()"
              value="{{ 'SHARED.Search' | translate}}" />
          <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetReport()"
              value="{{ 'SHARED.ResetSearch' | translate}}" />
          <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="ExportExcel()"
              value="{{ 'SHARED.REPORTS.EXPORT_EXCEL' | translate}}" />
      </div>
  </div>
  <!-- <app-grid-view #EBookingReport [HasMenu]="HasMenu"></app-grid-view> -->


<div class="noMenu-table">
  <!-- <app-grid-view #MyAgents [IsHtml]="IsHtml" [HasMenu]="HasMenu" (loadItemsMenu)="loadItemsMenu($event)"></app-grid-view> -->

  <app-grid-view #CrewChangeReport [customMenuTemplate]="reportListTemplate" [IsHtml]="IsHtml" [HasMenu]="HasMenu"
  (loadItemsMenu)="loadItemsMenu($event)"></app-grid-view>

<ng-template #reportListTemplate let-item let-menuItems="menuItems">

  <!-- <li role="menuitem" *ngIf="isAdmin" >
      <a class="dropdown-item" (click)="getPendingTask(item.RequestId)">
         {{'FRONT_USER.PENDING_TASKS'|translate}}
      </a>
  </li> -->
  <li role="menuitem" *ngIf="!item.IsPostedToSCA 
  && item.RequestStatusId != serviceStatusLookup.CrewChange_RequestPendingReview 
  && item.RequestStatusId != serviceStatusLookup.CrewChange_MoreInformationRequestedFromAgent
  && item.RequestStatusId != serviceStatusLookup.CrewChange_PendingApproval
  && item.RequestStatusId != serviceStatusLookup.CrewChange_MoreInformationRequestedFromReviewer" >
    <a class="dropdown-item" (click)="postRequestToSCA(item.RequestId)">
       {{'FRONT_USER.POST_REQUEST_TO_SCA_TEAM'|translate}}
    </a>
</li>

</ng-template>
</div>
</div>
